import { CatToast } from '@blocks-react/components/Toast';
import { FC, useCallback } from 'react';
import { CatIconSuccess } from '@blocks-react/components/Icons/Success';
import { CatHeading } from '@blocks-react/components/Heading';
import { RequestSerivceToastProps } from '../types';
import { TOAST_TYPE } from '../constants';
import { CatIconWarningCircle } from '@blocks-react/components/Icons/WarningCircle';

export const RequestSerivceToast: FC<RequestSerivceToastProps> = ({
  ...CatToastProps
}) => {
  const getIcon = useCallback(() => {
    if (CatToastProps.variant === TOAST_TYPE.SUCCESS) {
      return <CatIconSuccess slot="before" />;
    }
    return <CatIconWarningCircle slot="before" />;
  }, [CatToastProps.variant]);

  const getVariant = () => {
    if (CatToastProps.variant === TOAST_TYPE.SUCCESS) {
      return 'success';
    }
    else if (CatToastProps.variant === TOAST_TYPE.ERROR) {
      return 'error';
    }
    return undefined;
  };

  return (
    <CatToast
      {...CatToastProps}
      variant={getVariant()}
    >
      {getIcon()}
      <CatHeading variant="label" data-testid="toast-heading">
        {CatToastProps.message}
      </CatHeading>
    </CatToast>
  );
};
